import { ChainId, JSBI } from '@yetiswap/sdk';
import React from 'react';
import Loader from '../../../../../components/Loader';
import { YTS } from '../../../../../constants';
import { useActiveWeb3React } from '../../../../../hooks';
import { useGetNFTPrice } from '../../../../../hooks/useNFTMarketPlace';
import { useCalculatePrice, useClaimNFT, useCurrentPrice, useGetTotalSupply, useHasSaleStarted } from '../../../../../hooks/useYetiSummerCollection';
import { lastSummerNFT } from '../../../../../services/NFTMarketPlace/ApiCall';
import NFTPriceSymbol from '../../../components/NFTPriceSymbol';
import Scrollbar from '../../../components/Scrollbar';
import { SaleTokenList } from '../../../data/SaleTokenList';
import Counter from '../../../newComponents/Counter';
import NFTButton from '../../../newComponents/NFTButton';
import { SCCharacterItem, SCCharacterList, SCCharacterListWrapper, SCInfoWrapper, SCLastClaimedWrapper, SCMintSection, SCPrices, SCSalePageWrapper, SCTopContent } from './styled';
import WhoIsNext from '../../../../../assets/images/characters/who-is-next.png'
import { useHistory } from 'react-router-dom';
import { YetiSwapData } from '../../../data/NFTCollections/YetiSwapData';
import {
    minerYetiList,
    parachutingYetiList,
    picnickerYetiList,
    surferYetiList,
    swimmerYetiList,
    adventurerYetiList,
    YetiType,
    YetiItem
} from './data/yetiTypeList'
import { useWalletModalToggle } from '../../../../../state/application/hooks';


const SummerCollectionSalePage = () => {
    const { account, active } = useActiveWeb3React();
    const yts = YTS[ChainId.AVALANCHE];
    const [amount, setAmount] = React.useState<number>(1);
    const [mintEnable, setMintEnable] = React.useState<boolean>(true);
    const [latestImage, setLatestImage] = React.useState<any>(null);
    const [remainingMint, setRemainingMint] = React.useState<YetiItem[]>([]);
    const navigator = useHistory();
    const currentPrice = useCurrentPrice();
    const totalClaimed = useGetTotalSupply();
    const hasSale = useHasSaleStarted();
    const calculatingPrice = useCalculatePrice(amount);
    const CurrentPriceText: string = useGetNFTPrice(currentPrice, yts, hasSale);
    const CalculatingPriceText: string = useGetNFTPrice(calculatingPrice, yts, hasSale)
    const { claimNFTCallback } = useClaimNFT(amount, JSBI.BigInt(calculatingPrice ? calculatingPrice : 0).toString())
    const lastClaimURL = `/nft-detail/${YetiSwapData[0].tokenAddress}/${latestImage?.id || 0}`;
    const toggleWalletModal = useWalletModalToggle()

    React.useEffect(() => {
        if (totalClaimed !== 0) {
            lastSummerNFT().then(res => setLatestImage(res))
        }
    }, [totalClaimed]);

    React.useEffect(() => {
        const allYetiList = [
            ...parachutingYetiList,
            ...surferYetiList,
            ...adventurerYetiList,
            ...swimmerYetiList,
            ...picnickerYetiList,
            ...minerYetiList
        ]

        Promise.all(
            allYetiList.map(yetiItem => {
                return fetch(`https://api.yetiswap.app/remaining/${yetiItem.rarity}/${yetiItem.name}/${yetiItem.type}`)
                    .then(res => res.json())
                    .then(res => {
                        return {
                            ...yetiItem,
                            remaining: res[0].result
                        }
                    })
                    .catch(() => console.error(`${yetiItem.name} ${yetiItem.type}`))
            })
        ).then((res: any) => setRemainingMint(res))
    }, [])

    const onChange = (count: number) => {
        setAmount(count);
    }

    const minNFT = () => {
        if (!account) {
            toggleWalletModal();
        } else if (claimNFTCallback && mintEnable && calculatingPrice > 0 && hasSale) {
            setMintEnable(false)
            claimNFTCallback().then(e => {
                setMintEnable(true)
            })
        }
    }

    const onClickLastClaimed = () => {
        navigator.push(lastClaimURL)
    }

    const getRemainingYetiList = (yetiType: YetiType) => {
        return remainingMint.filter(yeti => yeti.name === yetiType)
    }


    const renderYetiItem = (data: YetiItem) => {
        return (
            <SCCharacterItem className={data.type}>
                <img src={data.image} />
                <span>{data.remaining ? `Remaining: ${data.remaining} out of ${data.total}` : "Sold Out!"}</span>
                <span>{`${data.type} - ${data.rarity}`}</span>
            </SCCharacterItem>
        )
    }

    return (
        <Scrollbar>
            <SCSalePageWrapper>
                <SCTopContent>
                    <SCLastClaimedWrapper>
                        {latestImage ? (
                            <>
                                <h3>Last Claim: {latestImage.name}</h3>
                                <img src={`https://ipfs.io/ipfs/${latestImage.image}`} onClick={onClickLastClaimed} title={lastClaimURL} />
                            </>
                        ) : <div className='loading'><Loader size='50px' /></div>}
                    </SCLastClaimedWrapper>
                    <SCInfoWrapper>
                        <h2>YetiSwap Summer Collection</h2>
                        <p>
                            It is a special series of NFT which is limited only to 300 NFTs, created with 6 different types and 3
                            different color options, created by Yetiswap especially for the summer of 2021.
                        </p>
                        <SCPrices>
                            <div className='left'>
                                <h4>Prices</h4>
                                <span>0-19 {'->'} 2 AVAX</span>
                                <span>20-49{'->'} 3 AVAX</span>
                                <span>50-99 {'->'} 4 AVAX</span>
                                <span>100-149 {'->'} 5 AVAX</span>
                                <span>150-199 {'->'} 6 AVAX</span>
                                <span>200-300 {'->'} 8 AVAX</span>
                            </div>
                            <div className='right'>
                                <h4>Current Price</h4>
                                <span>
                                    {CurrentPriceText}
                                    <NFTPriceSymbol symbol={"AVAX"} image={SaleTokenList[1].image} />
                                </span>
                                <h5>What is next?</h5>
                                <img width={300} src={WhoIsNext} alt="What Is Next" />
                            </div>
                        </SCPrices>
                    </SCInfoWrapper>
                </SCTopContent>
                <SCMintSection>
                    <Counter onChange={onChange} max={5} min={1} />
                    <span>
                        {CalculatingPriceText}
                        <NFTPriceSymbol symbol={"AVAX"} image={SaleTokenList[1].image} />
                    </span>
                    <NFTButton style={{ flex: 'unset', width: '200px' }} onClick={minNFT} disabled={!mintEnable}>{account && active ? "Mint" : "Connect Your Account to Mint"}</NFTButton>
                </SCMintSection>

                <SCCharacterListWrapper>
                    <h2>Character List</h2>

                    <h3>{YetiType.Parachuting}</h3>
                    <SCCharacterList>
                        {getRemainingYetiList(YetiType.Parachuting).map(renderYetiItem)}
                    </SCCharacterList>

                    <h3>{YetiType.Adventurer}</h3>
                    <SCCharacterList>
                        {getRemainingYetiList(YetiType.Adventurer).map(renderYetiItem)}
                    </SCCharacterList>

                    <h3>{YetiType.Picnicker}</h3>
                    <SCCharacterList>
                        {getRemainingYetiList(YetiType.Picnicker).map(renderYetiItem)}
                    </SCCharacterList>

                    <h3>{YetiType.Surfer}</h3>
                    <SCCharacterList>
                        {getRemainingYetiList(YetiType.Surfer).map(renderYetiItem)}
                    </SCCharacterList>

                    <h3>{YetiType.Miner}</h3>
                    <SCCharacterList>
                        {getRemainingYetiList(YetiType.Miner).map(renderYetiItem)}
                    </SCCharacterList>

                </SCCharacterListWrapper>
            </SCSalePageWrapper>
        </Scrollbar>
    )
}
export default SummerCollectionSalePage;